export default "__VITE_ASSET__278bdbbc__"